import { useAvatar } from "@/hooks/useAvatar";
import React from "react";

export function Avatar({ name = "", image = "", size = "md" , className }) {
  const { initials, bgColor, avatarClass } = useAvatar({ name, image, size });

  return (
    <div
      title={name}
      className={avatarClass + " " + className}
      style={{ backgroundColor: !image ? bgColor : undefined }}
    >
      {image ? (
        <img src={image} alt={name} className="w-full h-full object-cover" />
      ) : (
        initials
      )}
    </div>
  );
}
